import React, { useEffect, useState, useCallback } from "react";
import { Box, Flex, Spinner, useToast } from "@chakra-ui/react";
import ApiResponse from "../../../services/ApiResponse";
import TableCRUD from "../../../components/TableCRUD";
import { getDecodedToken } from "../../../services/Token";
import { Carrera } from "../../../services/models/Carrera";
import UnauthorizedPage from "../../UnauthorizedPage";
import ServerErrorPage from "../../ServerErrorPage";

const HEADERS = [
  "ID", "Nombre", "Tipo", "Descripción", "Plan de Estudio", 
  "Modalidad", "Cupo", "Duración Años", "Duración Meses", 
  "Fecha de Inscripción", "Cierre de Inscripción", 
  "Inicio de Cursado", "Turno", "Observación", "Prioridad"
];

const CarrerasTablePage = () => {
  const [response, setResponse] = useState(new ApiResponse<Carrera[]>());
  const decoded = getDecodedToken();
  const toast = useToast();

  const fetchCarreras = useCallback(async () => {
    if (!decoded?.institucion_id) return;

    const apiResponse = new ApiResponse<Carrera[]>();
    await apiResponse.useFetch(
      `carreras/institucion/${decoded.institucion_id}`,
      "GET"
    );

    if (apiResponse.data) {
      apiResponse.data.sort((a, b) => a.nombre.localeCompare(b.nombre));
    }

    setResponse(apiResponse);
  }, [decoded?.institucion_id]);

  useEffect(() => {
    fetchCarreras();
  }, [fetchCarreras]);

  if (response.loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" thickness="4px" speed="0.65s" color="teal.500" />
      </Flex>
    );
  }

  switch (response.responseCode) {
    case 200:
      return (
        <Box p={5} minH="100vh">
          <TableCRUD
            tableName="Carreras"
            headers={HEADERS}
            data={response.data || []}
            infoColumn="nombre"
          />
        </Box>
      );
    case 401:
      return <UnauthorizedPage />;
    case 999:
    default:
      if (!response.loading && response.responseCode !== 0) {
        return <ServerErrorPage />;
      }
      return null;
  }
};

export default CarrerasTablePage;